const KEY = "jwt_token";
const REFRESH_KEY = "refresh_token";

export function getToken() {
    try {
        return localStorage.getItem(KEY) || "";
    } catch {
        return "";
    }
}

export function setToken(token) {
    localStorage.setItem(KEY, token);
}

export function getRefreshToken() {
    try {
        return localStorage.getItem(REFRESH_KEY) || "";
    } catch {
        return "";
    }
}

export function setRefreshToken(token) {
    localStorage.setItem(REFRESH_KEY, token);
}

export function removeToken() {
    localStorage.removeItem(KEY);
}

export function clearAuthStorage() {
    localStorage.removeItem(KEY);
    localStorage.removeItem(REFRESH_KEY);
}

export function authHeaders() {
    const t = getToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
}
